import React, { Component } from "react";
import { AppConstants } from "../../configApp";
import Strings from "@my-dld/assets/strings";
import Popup from "@my-dld/components/Popup/Popup";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { StringUtil } from "@eres/core";
import { normaliseMobileNumber } from "@eres/core/dist/StringUtils";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { showMessage } from "@my-dld/utils/UIUtils";
import moment, { Moment } from "moment";
import { RegistrationApi } from "@10x/tabu-mobile-api";
import { DNRDModelX } from "./utils";

interface Props {
	mobile: string;
	profileHash: string;
	onDismiss: () => void;
	onVerified: ( profile: DNRDModelX ) => void;
}

interface State {
	mobile?: string;
	maskedMobile?: string;
	otp?: string;
	error?: string;
	isLoading?: boolean;
	otpStatus?: boolean;
	remainTime?: string,
	resending: boolean,
}

export function toClockString( value: number ): string {
	return ( value ).toLocaleString( "en-US", { minimumIntegerDigits: 2, useGrouping: false } );
}

class VerifyPopup extends Component<Props, State> {
	_otpTimer: any = undefined;
	resendDate?: Moment;
	resendTimer?: any;

	constructor( props: Props ) {
		super( props );
		let mobile = props.mobile;
		let mobileMasked = mobile;
		this.state = {
			mobile: mobile,
			maskedMobile: mobileMasked,
			otpStatus: true,
			resending: false,
		};
		this.resetOTPTimer();
	}


	componentWillUnmount(): void {
		if ( this.resendTimer ) {
			clearTimeout( this.resendTimer );
			this.resendTimer = 0;
		}
	}

	render() {
		let { mobile, error } = this.state;
		return (
			<Popup
				id={ "token-verify" } showCloseButton={ true } clickOutsideToDismiss={ false }
				onDismiss={ this.props.onDismiss } showIcon={ false }>
				<div className="text-center"><img
					className="mt-3 mb-3"
					src={ `${ AppConstants.rootUrl }assets/img/password.png` }/>
				</div>
				<div className="text-center"><strong>{ Strings.verification }</strong></div>
				<p className="mt-2 text-center">{ Strings.dnrd_mobile_info }</p>
				<p className="mt-2 text-center">
					{ Strings.we_have_sent_an_one_time_password_to_your_registered_mobile_number } { this.state.maskedMobile }</p>
				<p className="mt-2 text-center">{ Strings.please_enter_the_verification_code }</p>
				<div className="form-group field-style mb-4 text-center">
					<input
						className="form-control text-center otp-field" placeholder="******"
						value={ this.state.otp ?? "" }
						onChange={ ( e ) => {
							this.setState( {
								otp: e.target.value
							} );
						} }
						onKeyUp={ e => {
							if ( e.keyCode === 13 ) {
								this.onVerify();
							}
						} }
						type="number"/>
				</div>
				{ error && <div className={ "invalid-feedback invalid-feedback-x" }>
					{ error }
				</div> }
				<div className="form-group mb-4 mb-0 text-center">
					<button
						className="btn btn_1 otp-btn"
						type="button" onClick={ this.onVerify }>
						{ ( this.state.isLoading ) ? <div className="relative spinner-border " role="status">
							<span className="sr-only">{ Strings.loading }</span>
						</div> : Strings.verify }
					</button>
				</div>
				<div className="form-group mb-4 mb-0 text-center">
					<button
						disabled={ this.state.otpStatus }
						className="btn btn_1 otp-btn"
						type="button" onClick={ this.resendOTP }>
						{ ( this.state.resending ) ? <div className="relative spinner-border " role="status">
                            <span
	                            className="sr-only"
	                            style={ { color: this.state.otpStatus ? "#9f9f9f" : "#ffffff" } }>{ Strings.loading }</span>
						</div> : Strings.resend_otp + ( this.state.remainTime ? `\n${ this.state.remainTime }` : "" ) }
					</button>
				</div>
			</Popup>
		);
	}

	onVerify = () => {
		const state = this.state;
		if ( state.isLoading )
			return;
		if ( StringUtil.isEmptyStringOrNull( state.otp ) || state.otp!.length < 3 ) {
			this.setState( { error: Strings.invalid_otp } );
			return;
		}
		this.setState( { isLoading: true } );
		let apiHandler = ( response: any ) => {
			this.setState( { isLoading: false } );
			let profile = response.Response;
			if ( profile ) {
				JQModal( "token-verify" ).hide();
				this.props.onVerified( profile );
			} else {
				this.setState( { error: Strings.invalid_otp } );
			}
		};
		let apiExHandler = ( reason: any ) => {
			this.setState( { isLoading: false } );
			this.setState( { error: Strings.invalid_otp } );
		};
		RegistrationApi.verifyOTPForEIDA( state.otp!, this.props.profileHash )
		.then( apiHandler ).catch( apiExHandler );
	};

	resendOTP = () => {
		this.setState( { resending: true } );
		trackEventWithData( "Register", "ResendVerifyPhone", { phone: this.state.mobile } );
		this.verifyPhone( normaliseMobileNumber( this.state.mobile! ) );
	};

	verifyPhone( mobile: string ) {
		let apiHandler = ( ok: boolean ) => {
			if ( ok ) {
				this.resetOTPTimer();
				this.setState( {
					otp: "", resending: false,
					otpStatus: true,
				} );
				showMessage( Strings.token_resend );
			} else {
				this.setState( { resending: false } );
				showMessage( Strings.token_resend_failed );
			}
		};
		let apiExHandler = ( reason: any ) => {
			this.setState( { resending: false } );
			showMessage( Strings.token_resend_failed + "\n" + reason.toString() );
		};
		RegistrationApi.generateOTPForEIDA( this.props.profileHash )
		.then( response => {
			apiHandler( response );
		} )
		.catch( reason => {
			apiExHandler( reason );
		} );
	}

	updateResendLabel = () => {
		if ( this.resendDate ) {
			const diff = this.resendDate.diff( new Date() );
			if ( diff > 0 ) {
				let duration = moment.duration( diff );
				this.setState( {
					remainTime: toClockString( duration.hours() ) + ":" + toClockString( duration.minutes() )
						+ ":" + toClockString( duration.seconds() ),
				} );
			} else {
				if ( this.resendTimer ) {
					clearTimeout( this.resendTimer );
				}
				this.setState( {
					remainTime: undefined,
					otpStatus: false,
				} );
			}
		}
	};

	componentDidMount(): void {
		JQModal( "token-verify" ).show();
	}

	private resetOTPTimer() {
		this.resendDate = moment( new Date() ).add( 2, "minutes" );
		this.resendTimer = setInterval( this.updateResendLabel, 500 );
	}
}

export default VerifyPopup;
